// incomeSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
const apiUrl = process.env.REACT_APP_API_URL;
// Async thunk for fetching incomes
export const fetchIncomes = createAsyncThunk(
  'income/fetchIncomes',
  async (_, { getState }) => {
    const { clientId, financialYear } = getState().app;
    const response = await fetch(`${apiUrl}/api/incomes?clientId=${clientId}&financialYear=${financialYear}`);
    if (!response.ok) {
      throw new Error('Failed to fetch incomes');
    }
    return response.json();
  }
);

// Async thunk for adding an income
export const addIncome = createAsyncThunk(
  'income/addIncome',
  async (newIncome, { rejectWithValue }) => {
    try {
      const response = await fetch(`${apiUrl}/api/incomes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newIncome),
      });
      if (!response.ok) {
        throw new Error('Failed to add income');
      }
      return response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk for updating an income
export const updateIncome = createAsyncThunk(
  'income/updateIncome',
  async (updatedIncome, { rejectWithValue }) => {
    try {
      const response = await fetch(`${apiUrl}/api/incomes/${updatedIncome.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedIncome),
      });
      if (!response.ok) {
        throw new Error('Failed to update income');
      }
      return response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk for deleting an income
export const deleteIncome = createAsyncThunk(
  'income/deleteIncome',
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetch(`${apiUrl}/api/incomes/${id}`, {
        method: 'DELETE',
      });
      if (!response.ok) {
        throw new Error('Failed to delete income');
      }
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Initial state
const initialState = {
  incomes: [],
  loading: false,
  error: null,
};

// Slice
const incomeSlice = createSlice({
  name: 'income',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIncomes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIncomes.fulfilled, (state, action) => {
        state.loading = false;
        state.incomes = action.payload;
      })
      .addCase(fetchIncomes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addIncome.fulfilled, (state, action) => {
        state.incomes.push(action.payload);
      })
      .addCase(updateIncome.fulfilled, (state, action) => {
        const index = state.incomes.findIndex((income) => income.id === action.payload.id);
        if (index !== -1) {
          state.incomes[index] = action.payload;
        }
      })
      .addCase(deleteIncome.fulfilled, (state, action) => {
        state.incomes = state.incomes.filter((income) => income.id !== action.payload);
      })
      .addCase(addIncome.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateIncome.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteIncome.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default incomeSlice.reducer;
